import { useEffect, useState } from 'react'

/** `value` once it has stopped changing for `delayMs`.
 *
 *  The status-email preview's note (S-15) is the first consumer: the note is
 *  part of the preview's query key, and a key that moved on every keystroke
 *  would ask the server to render the whole email once per letter. The
 *  language and the selection feed the key directly — a pick is one change,
 *  not a burst.
 *
 *  The FIRST value is answered at once, so a sheet that opens with an empty
 *  note previews without waiting out the delay. Every later change restarts the
 *  timer, and a value typed and undone inside one pause never surfaces. */
export function useDebouncedValue<T>(value: T, delayMs: number): T {
  const [settled, setSettled] = useState(value)

  useEffect(() => {
    const timer = window.setTimeout(() => setSettled(value), delayMs)
    return () => window.clearTimeout(timer)
  }, [value, delayMs])

  return settled
}
